import * as yup from "yup";
import { BASIC_AUTHENTICATION_ERROR } from "../constants/errorMessages";
import REGEX from "../constants/constants";

// Yup validation schema for sign up form using custom error messages
const { EMAIL_PATTERN,WEBSITE_PATTERN, INSTAGRAM_PATTERN } = REGEX;
export const step1Schema = yup.object({
  emailAddress: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_USERNAME_REQ)
    .matches(EMAIL_PATTERN, BASIC_AUTHENTICATION_ERROR.EMAIL)
    .max(254, BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_LENGTH),

  password: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_REQUIRED_PASSWORD)
    .min(8, BASIC_AUTHENTICATION_ERROR.MSG_PASSWORD_TYPE)
    .max(50, BASIC_AUTHENTICATION_ERROR.MAX_CHARECTERS.replace("{{NAME}}", "Password")),
  sellerName: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.SELLER_NAME_REQUIRED)
    .max(50, BASIC_AUTHENTICATION_ERROR.MAX_CHARECTERS.replace("{{NAME}}", "Seller")),
  brandName: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.BRAND_NAME_REQUIRED)
    .max(50, BASIC_AUTHENTICATION_ERROR.MAX_CHARECTERS.replace("{{NAME}}", "Brand Name")),
  businessName: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.BUSINESS_NAME_REQUIRED)
    .max(50, BASIC_AUTHENTICATION_ERROR.MAX_CHARECTERS.replace("{{NAME}}", "Business Name")),
  website: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.WEBSITE_MATCH)
    .matches(WEBSITE_PATTERN, BASIC_AUTHENTICATION_ERROR.WEBSITE_MATCH),
});

export const step2Schema = yup.object({
  Appareltype: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.APPAREL_TYPE_REQUIRED)
    .max(50, BASIC_AUTHENTICATION_ERROR.MAX_CHARECTERS.replace("{{NAME}}", "Apparel Type")),
  Categories: yup
    .array()
    .required(BASIC_AUTHENTICATION_ERROR.CATEGORIES_REQUIRED)
    .min(1, BASIC_AUTHENTICATION_ERROR.CATEGORIES_REQUIRED)
    .max(50, BASIC_AUTHENTICATION_ERROR.MAX_CHARECTERS.replace("{{NAME}}", "Categories")),
  ManufacturLocation: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MANUFATURE_LOCATION_REQUIRED),
  inventoryStorage: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.INVENTORY_STORAGE_REQUIRED),
  zipCode: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.ZIP_CODE_REQUIRED)
    .min(5, BASIC_AUTHENTICATION_ERROR.ZIP_CODE_MINIMUM)
    .max(6, BASIC_AUTHENTICATION_ERROR.ZIP_CODE_MAXIMUM),
  city: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.CITY_REQUIRED),
  country: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.COUNTRY_REQUIRED),
  streetAddress: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.STREET_ADDRESS_REQUIRED)
});
export const step3Schema = yup.object({
  instagram: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      "isValidInstagram",
      BASIC_AUTHENTICATION_ERROR.INSTAGRAM_MATCH,
      (value) => {
        if (!value) return true;
        return INSTAGRAM_PATTERN.test(value);
      }
    ),
  other: yup
  .string()
  .nullable()
  .notRequired()
  .test(
    "isValidWebsite",
    BASIC_AUTHENTICATION_ERROR.BASIC_URL,
    (value) => {
      if (!value) return true;
      return WEBSITE_PATTERN.test(value);
    }
  )
});
